import angular from 'angular';
import '../shared.module';
import { formatPhone } from '../../core/helpers/phone.helper';

angular.module('app.shared').filter('cpPhone', () => formatPhone);
